﻿let BookmarkTable: DataTables.DataTable = null;

let BookmarkData: any = null;

namespace WebPortal.Default {
    export class BookmarkHandler {
        constructor() { this.init(); }

        private init(): void {
            $('#nav_bookmark').off().on('click', () => {
                if (!BookmarkData) {
                    Show_Status_Message({ title: "Favorites Preparation", message: "Loading Favorites Data", progress: true })
                    WebPortalHubObj.server.doBookmarkRequest($("#hdf_se_request_param").val());
                }
                setTimeout(() => { this.resize(); }, 500);
            });

            $('#tbl_bookmark_area').off().on('dblclick', 'tr', (e: JQueryEventObject) => {
                NewSessionCustomerData = BookmarkTable.row(e.currentTarget).data();
                NewSessionCustomerData.RequestType = nscdi_Bookmark;
                return (navigationHandler as WebPortal.Navigation.Default.NavigationDefaultHandler).startChecksForLoadCustomer();
            }).on('click', '.openCustomer', (e: JQueryEventObject) => {
                NewSessionCustomerData = BookmarkTable.row($(e.currentTarget).closest('tr')).data();
                NewSessionCustomerData.RequestType = nscdi_Bookmark;
                return (navigationHandler as WebPortal.Navigation.Default.NavigationDefaultHandler).startChecksForLoadCustomer();
            }).on('click', '.editCustomer', (e: JQueryEventObject) => {
                NewSessionCustomerData = BookmarkTable.row($(e.currentTarget).closest('tr')).data();
                NewSessionCustomerData.RequestType = nscdi_Bookmark_edit;
                return (navigationHandler as WebPortal.Navigation.Default.NavigationDefaultHandler).startChecksForLoadCustomer();
            });
        }

        public PrepareBookmarkArea(_BookmarkData: any): void {
            // console.info(JSON.stringify(_BookmarkData));

            if (!!_BookmarkData && !!_BookmarkData.Favorite) {
                BookmarkData = _BookmarkData;
                BookmarkTable = $('#tbl_bookmark_area').DataTable(
                    {
                        "destroy": true,
                        "ordering": true,
                        "order": [[2, 'asc'], [4, 'asc']],
                        "paging": false,
                        "searching": false,
                        "info": false,
                        "dom": 'lrtip',
                        "processing": true,
                        "data": _BookmarkData.Favorite,
                        "columns": [
                            {
                                "data": null,
                                "createdCell": (cell: Node, cellData: any, rowData: any, row: number, col: number) => {
                                    (navigationHandler as WebPortal.Navigation.Default.NavigationDefaultHandler).SetOpenEditButton(cell, cellData, rowData, row, col)
                                }
                            },
                            { "data": "ID" },
                            { "data": "V1" },
                            { "data": "V4" },
                            { "data": "V2" },
                            { "data": "V3" },
                            {
                                "defaultContent": "DelBookmarkButton",
                                "createdCell": (cell: Node, cellData: any, rowData: any, row: number, col: number) => {
                                    (navigationHandler as WebPortal.Navigation.Default.NavigationDefaultHandler).SetSecurityProperties(cell, cellData, rowData, row, col)
                                }
                            }
                        ],
                        "columnDefs": [
                            { "targets": [1], "visible": false }
                        ],
                        "responsive": true,
                        "scrollY": "100%",
                        "scrollX": false,
                        "scrollCollapse": true,
                    }
                );

                Close_Status_Message();
            }

            (navigationHandler as WebPortal.Navigation.Default.NavigationDefaultHandler).ActiveSecurityProperties();
        }

        public resize(): void {
            let MaxDivHeight = $(window).height() - (12 + $('#pn_default_navigation').height() + 38 + 55);
            let BookmarkDataTable = $($('#tbl_bookmark_area_wrapper').find('div.dataTables_scrollBody')[0]);
            if (!!BookmarkDataTable) {
                if (MaxDivHeight > 300) {
                    BookmarkDataTable.height(MaxDivHeight.toString() + "px");
                } else {
                    BookmarkDataTable.height("100%");
                }
                if (!!BookmarkTable) {
                    // Die Tabelle wird zweimal neu ausgerichtet. Dies, da beim ersten Mal die Tabelle nicht korrekt angzeigt wird
                    setTimeout(() => { BookmarkTable.columns.adjust(); }, 500);
                    setTimeout(() => { BookmarkTable.columns.adjust(); }, 200);
                }
            }
        }
    }
}